<template>
  <div class="three-list">
    <div
      v-for="(item, index) in data"
      :key="index"
      class="three-list-item"
      :class="{ active: index === targeIndex }"
      @click="itemClick(item)"
    >
      <div class="three-list-item-image-box">
        <img
          @click.prevent
          class="three-list-item-image"
          :src="item[keys.imgUrl]"
          onerror="this.src='https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210106174055551-common_pic_default@3x.png'"
        />
      </div>
      <div class="three-list-item-data">
        <div class="three-list-item-name h3">
          {{ item[keys.title] }}
        </div>
        <div class="three-list-item-time">{{ item[keys.time] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThreeList",
  props: {
    data: Array,
    keys: {
      type: Object,
      default() {
        return {
          imgUrl: "photo",
          title: "title",
          time: "date",
        };
      },
    },
  },
  data() {
    return {
      targeIndex: 0,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    itemClick(item) {
      this.$emit("tap", { ...item });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";
.three-list {
  margin-left: -24px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  @include media(
    (
      $sm: (
        margin-left: auto,
        margin-right: auto,
      ),
    )
  );
  @include setThemeClass {
    .three-list-item {
      cursor: pointer;
      margin-bottom: 24px;
      margin-left: 24px;
      width: 328px;
      transition: box-shadow 0.2s $easeOutCubic, transform 0.5s $easeOutCubic;
      @include media(
        (
          $md: (
            width: 344px,
          ),
          $sm: (
            width: 100%,
            margin-left: 0,
          ),
        )
      );
      background-color: getThemeVal(brandColorWhite);
      border-radius: 4px;
      overflow: hidden;
      .three-list-item-image-box {
        overflow: hidden;
        .three-list-item-image {
          display: block;
          width: 100%;
          height: 246px;
          object-fit: cover;
          transition: transform 0.6s $easeOutCubic;
          @include media(
            (
              $md: (
                height: 258px,
              ),
              $sm: (
                height: 251px,
              ),
            )
          );
        }
      }
      .three-list-item-data {
        padding: 20px 20px 30px;
        .three-list-item-name {
          @include maxLine(2, 60px);
        }
        .three-list-item-time {
          margin-top: 20px;
          @include h4(getThemeVal(textSubtitleColor));
          font-weight: 500;
        }
      }
    }
    .three-list-item:hover {
      transform: translateY(-4px);
      box-shadow: $boxShadow;
      .three-list-item-image {
        transform: scale(1.1, 1.1);
      }
    }
  }
}
</style>
